import { post } from '@webapp-next/lib/request/webapp/http';

export default async function employmentConditionGet(id = 0, association = []) {
  const body = {
    start: 0,
    sort: {
      Name: 'asc',
    },
    assoc: association,
    // max: 50,
  };

  const options = {
    headers: {
      'dp-meta-option': 'none',
    },
  };

  if (id) {
    body.search = [{ field: 'Id', type: 'eq', data: id }];
  }

  try {
    const { data } = await post(
      '/api/v1/resource/EmploymentCondition/QUERY',
      body,
      options
    );

    return {
      success: true,
      message: '',
      data: data || [],
    };
  } catch (e) {
    console.error(e);
    throw e;
  }
}
